import NewItemReceive from "../../../../components/@documents/item_receives/NewItemReceive";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReceiveNewPage() {

    return (
        <NewItemReceive 
            routeType={routeTypes.retail}
        />
    )
}